import { createElement } from "./utilities.js";

export function tooltipBuilder(trigger, index, tooltipInnerHtml) {
    const tooltipFragment = new DocumentFragment();
    const tooltip = createElement("div", ["cTooltip"], {
        'data-tooltipContent': "",
        'role': 'tooltip',
        'aria-hidden': 'true',
        'id': `tooltip${index}`
    });
    const tooltipInner = createElement("div", ["cTooltip__area", "cTooltip__area--content"]);
    const tooltipBackground = createElement("div", ["cTooltip__area", "cTooltip__area--background"]);
    const tooltipTriangle = createElement("div", ["cTooltip__area", "cTooltip__area--triangle"]);
    tooltipInner.innerHTML = tooltipInnerHtml;
    tooltip.append(tooltipBackground, tooltipTriangle, tooltipInner);
    tooltipFragment.append(tooltip);
    return tooltip;
}